import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataIdentityData } from '@onefootprint/request-types/dashboard';
import type { NodeProps } from '@/playbook-builder/playbook-builder.types';
import useStore from '../../hooks/use-store';
import BaseNode from '../base-node';
import IdentityContent from './components/identity-content';
export const IdentityDataNode = node => {
  const $ = _c(7);
  const {
    data: t0
  } = useStore();
  const {
    canEdit
  } = t0;
  let t1;
  if ($[0] !== canEdit || $[1] !== node) {
    t1 = {
      form: "identity-data-form",
      size: "lg",
      render: t2 => {
        const {
          mutation,
          isFirmEmployee
        } = t2;
        return <IdentityContent node={node} mutation={mutation} canEdit={canEdit} isFirmEmployee={isFirmEmployee} />;
      }
    };
    $[0] = canEdit;
    $[1] = node;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== node.data || $[4] !== node.id || $[5] !== t1) {
    t2 = <BaseNode nodeId={node.id} data={node.data} sidebar={t1} />;
    $[3] = node.data;
    $[4] = node.id;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default IdentityDataNode;